import yup from '../../utils/yup';
import createTypedAction from '../createTypedAction';

export const PREFIX = '@@fox/dashboard/';

export const { fetchDcsPublication, FETCH_DCS_PUBLICATION }: any = createTypedAction(
  `${PREFIX}FETCH_DCS_PUBLICATION`
);
export const { fetchDcsPublicationSuccess, FETCH_DCS_PUBLICATION_SUCCESS }: any = createTypedAction(
  `${PREFIX}FETCH_DCS_PUBLICATION_SUCCESS`,
  ['publication', yup.immutable().map().nullable()]
);
export const { fetchDcsPublicationFailed, FETCH_DCS_PUBLICATION_FAILED }: any = createTypedAction(
  `${PREFIX}FETCH_DCS_PUBLICATION_FAILED`,
  ['err', yup.immutable().map().nullable()]
);

export const { fetchDcsDataPoints, FETCH_DCS_DATA_POINTS }: any = createTypedAction(
  `${PREFIX}FETCH_DCS_DATA_POINTS`,
  ['deviceIds', yup.immutable().list().required()]
);
export const { fetchDcsDataPointsSuccess, FETCH_DCS_DATA_POINTS_SUCCESS }: any = createTypedAction(
  `${PREFIX}FETCH_DCS_DATA_POINTS_SUCCESS`,
  ['dataPoints', yup.immutable().map().required()]
);
export const { fetchDcsDataPointsFailed, FETCH_DCS_DATA_POINTS_FAILED }: any = createTypedAction(
  `${PREFIX}FETCH_DCS_DATA_POINTS_FAILED`,
  ['err', yup.immutable().map().nullable()]
);

export const { fetchDcsMap, FETCH_DCS_MAP }: any = createTypedAction(
  `${PREFIX}FETCH_DCS_MAP`
);
export const { fetchDcsMapSuccess, FETCH_DCS_MAP_SUCCESS }: any = createTypedAction(
  `${PREFIX}FETCH_DCS_MAP_SUCCESS`,
  ['map', yup.immutable().map().nullable()]
);
export const { fetchDcsMapFailed, FETCH_DCS_MAP_FAILED }: any = createTypedAction(
  `${PREFIX}FETCH_DCS_MAP_FAILED`,
  ['err', yup.immutable().map().nullable()]
);

export const { createDcsPublication, CREATE_DCS_PUBLICATION }: any = createTypedAction(
  `${PREFIX}CREATE_DCS_PUBLICATION`,
  ['publication', yup.immutable().map().nullable()]
);

export const { updateDcsPublication, UPDATE_DCS_PUBLICATION }: any = createTypedAction(
  `${PREFIX}UPDATE_DCS_PUBLICATION`,
  ['publication', yup.immutable().map().required()]
);

export const { addDcsPoints, ADD_DCS_POINTS }: any = createTypedAction(
  `${PREFIX}ADD_DCS_POINTS`,
  ['deviceIds', yup.immutable().list().required()],
  ['dataPoints', yup.immutable().list().required()]
);

export const { removeDcsPoint, REMOVE_DCS_POINT }: any = createTypedAction(
  `${PREFIX}REMOVE_DCS_POINT`,
  ['pointId', yup.string().required()]
);

export const { resetDcsPoints, RESET_DCS_POINTS }: any = createTypedAction(
  `${PREFIX}RESET_DCS_POINTS`
);

export const { reassignDcsAddresses, REASSIGN_DCS_ADDRESSES }: any = createTypedAction(
  `${PREFIX}REASSIGN_DCS_ADDRESSES`,
  ['assignments', yup.immutable().list().required()]
);
